export default "__VITE_ASSET__dc76c704__"